import React from 'react';
import {Button, notification} from 'antd';

// A tab open since before a deploy keeps running the old build (the owner, 02.11, still saw the filters of 30.10 cut
// short; 04.11 Роман saw the old «Цена» of 6 260 000 where the new build shows 6 500 000): every two minutes, and when
// the tab or the window is shown again, the scripts the server's page lists are compared with the ones this page
// loaded; a new one brings a notice with «Обновить». Closing the notice only puts it off: it comes back at the next
// check, until the page is reloaded (owner 04.11: «если мы что-то новое выкатили, чтобы показывалось уведомление»).
const SCRIPTS = /\/static\/js\/[^"'\s>]+\.js/g;
const EVERY_MS = 2 * 60 * 1000;

const loadedScripts = () => new Set([...document.querySelectorAll('script[src]')]
  .map((s) => (s.getAttribute('src').match(SCRIPTS) || [])[0])
  .filter(Boolean));

export const watchNewVersion = () => {
  const loaded = loadedScripts();
  // a development build has no such scripts
  if (!loaded.size) return () => {};
  let shown = false;
  let busy = false;
  const check = async () => {
    if (shown || busy || document.visibilityState !== 'visible') return;
    busy = true;
    try {
      const response = await fetch('/', {cache: 'no-store'});
      if (!response.ok) return;
      const listed = (await response.text()).match(SCRIPTS) || [];
      if (!listed.length || listed.every((src) => loaded.has(src))) return;
      shown = true;
      notification.warning({
        key: 'new-version',
        message: 'Админка обновилась',
        description: 'Обновите страницу, чтобы работать в новой версии: в старой могут быть неверные цифры.',
        duration: 0,
        btn: <Button type='primary' size='small' onClick={() => window.location.reload()}>Обновить</Button>,
        onClose: () => {
          shown = false;
        },
      });
    } catch (error) {
      // offline: the next check tries again
    } finally {
      busy = false;
    }
  };
  const timer = setInterval(check, EVERY_MS);
  document.addEventListener('visibilitychange', check);
  window.addEventListener('focus', check);
  return () => {
    clearInterval(timer);
    document.removeEventListener('visibilitychange', check);
    window.removeEventListener('focus', check);
  };
};
